export default __webpack_public_path__ + "static/pathwise_doc_6-bb20f721075bd703ed7567a531b87472.gif";